import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import Link from '../../components/link/internal-link';
import { SearchIcon } from '../../components/icons';
import withTranslate from '../../hoc/with-translate';
import styles from './search-button.scss';

class SearchButton extends Component {
  render() {
    const { t } = this.props;
    return (
      <Link className={classNames(styles.button, 'search-button')} to="/search">
        <SearchIcon className="button-primary-icon-fill"/>
        <span className={styles.hiddenLabel}>
          {t('search-button.search')}
        </span>
      </Link>
    );
  }
}

SearchButton.propTypes = {
  t: PropTypes.func,
};

export default withTranslate(SearchButton);



// WEBPACK FOOTER //
// ./app/components/search-button/search-button.js